import React, { useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, Chip, Card, CardContent, Grid, TablePagination, useTheme
} from '@mui/material';
import { Person as Icon, Search as SearchIcon } from '@mui/icons-material';
import { useQuery } from 'react-query';

const fetchClientes = async () => {
  const res = await fetch('/api/clientes', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
  return res.json();
};

export default function Clientes() {
  const theme = useTheme();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { data } = useQuery('clientes', fetchClientes, { refetchInterval: 30000 });
  const clientes = data?.data || [];

  const filtered = clientes.filter(c =>
    !search || c.nombre?.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase()) ||
    c.telefono?.includes(search)
  );

  const pageData = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Icon sx={{ color: theme.palette.primary.main, fontSize: 32 }} />
        <Typography variant="h4" fontWeight={700}>Clientes</Typography>
        <Chip label={`${clientes.length} registrados`} size="small" variant="outlined" sx={{ ml: 'auto' }} />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography color="textSecondary" variant="caption">Total Clientes</Typography>
            <Typography variant="h4">{clientes.length}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography color="textSecondary" variant="caption">Activos</Typography>
            <Typography variant="h4">{clientes.filter(c => c.estado === 'activo').length}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography color="textSecondary" variant="caption">Inactivos</Typography>
            <Typography variant="h4">{clientes.filter(c => c.estado === 'inactivo').length}</Typography>
          </CardContent></Card>
        </Grid>
      </Grid>

      <TextField
        placeholder="Buscar clientes..." value={search} onChange={e => { setSearch(e.target.value); setPage(0); }}
        sx={{ my: 2, width: 320 }}
        InputProps={{ startAdornment: <SearchIcon sx={{ color: theme.palette.text.secondary, mr: 1, fontSize: 20 }} /> }}
        size="small"
      />

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Nombre</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Teléfono</strong></TableCell>
              <TableCell><strong>Documento</strong></TableCell>
              <TableCell><strong>Estado</strong></TableCell>
              <TableCell><strong>Registro</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageData.map(c => (
              <TableRow key={c.id} hover>
                <TableCell>{c.nombre || '—'}</TableCell>
                <TableCell>{c.email || '—'}</TableCell>
                <TableCell>{c.telefono || '—'}</TableCell>
                <TableCell>{c.documento || '—'}</TableCell>
                <TableCell>
                  <Chip
                    label={c.estado}
                    size="small"
                    color={c.estado === 'activo' ? 'success' : c.estado === 'ocupado' ? 'warning' : 'default'}
                  />
                </TableCell>
                <TableCell>{c.createdAt ? new Date(c.createdAt).toLocaleDateString('es') : '—'}</TableCell>
              </TableRow>
            ))}
            {pageData.length === 0 && (
              <TableRow><TableCell colSpan={6} align="center"><Typography color="textSecondary">Sin resultados</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div" count={filtered.length} page={page} onPageChange={(e, p) => setPage(p)}
          rowsPerPage={rowsPerPage} rowsPerPageOptions={[10, 25, 50]}
          onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
        />
      </TableContainer>
    </Box>
  );
}
